<template>
  <!-- 广播播放记录 -->
  <div class="page_box">
    <div class="page_table_box" style="height:calc(100% - 10px)">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                requestParams.pageSize * (requestParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column prop="voiceName" label="广播标题" align="center">
          </el-table-column>

          <el-table-column
            prop="userName"
            label="播放用户"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="addTime"
            label="播放时间"
            align="center"
            width="200"
          >
            <template slot-scope="rowData">
              {{ $Common.dateFormatDateTwo(rowData.row.addTime) }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestParams.pageNum"
          :page-size="requestParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BroadcastResourceManagement from "@/components/BroadcastResourceManagement";

export default {
  name: "",
  components: { BroadcastResourceManagement },
  props: {},
  data() {
    return {
      // 响应数据
      responseData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      // 请求数据
      requestParams: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1,
        pageSize: 20
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleCurrentChange(val) {
      this.requestParams.pageNum = val;
      this.getDataList();
      console.log(`当前页: ${val}`);
    },
    // 获取数据列表
    async getDataList() {
      var newParamData = {
        schoolId: this.requestParams.schoolId,
        pageNum: this.requestParams.pageNum,
        pageSize: this.requestParams.pageSize
      };

      let res = await this.$Http.getBroadcastRecord(newParamData);
      // console.log(res)
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize;
        this.responseData.pageNum = res.data.pageNum;
        this.responseData.total = res.data.total;
        this.responseData.pages = res.data.pages;
        this.responseData.list = res.data.list;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  created() {},
  mounted() {
    this.getDataList();
  }
};
</script>
<style scoped></style>
